import { useState } from "react";
import Joi from "joi-browser";
import { message } from "antd";

import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { showErrorToast } from "V2.0/utils";

const template = [
  {
    name: "prompt",
    label: "Prompt",
    type: "textArea",
    style: { height: "200px", fontSize: "13px" },
  },
];

const schema = {
  prompt: Joi.string().required().label("Prompt"),
};

export default function DocumentPromptEdit(props) {
  const { document, onClose, onDocumentPromptUpdate } = props;

  const [loading, setLoading] = useState(false);

  const referenceFor = document.referenceFor;
  const prompt = document.prompt;

  const inputField = {
    prompt,
  };

  const { data, handleChange, validate, error } = useForm(inputField, schema);

  const handleUpdate = () => {
    const lifecycleCbs = {
      init: (data) => {
        const { referenceFor } = data;
        setLoading(true);
        message.loading(`Updating ${referenceFor}'s prompt`);
      },
      success: (data) => {
        const { referenceFor } = data;
        const successMessage = `Updated ${referenceFor}'s prompt`;

        setLoading(false);
        message.destroy();
        message.success(successMessage);
        onClose();
      },
      error: (e, data) => {
        const { referenceFor } = data;
        const fallbackErrorMessage = `Failed to update ${referenceFor}'s prompt`;

        setLoading(false);
        message.destroy();
        showErrorToast(e, fallbackErrorMessage);
      },
    };

    const payload = {
      ...data,
      referenceFor,
    };

    onDocumentPromptUpdate(payload, lifecycleCbs);
  };

  const isSaveDisabled =
    validate(data, schema) || loading || Boolean(Object.keys(error).length);

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Update {referenceFor} Prompt</DialogTitle>
      <DialogBody>
        <Form
          data={data}
          handleChange={handleChange}
          error={error}
          template={template}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          loading={loading}
          onClick={handleUpdate}
          disabled={isSaveDisabled}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
